import normalizePath from 'normalize-path';

function join(...parts) {
  // remove any undefined or null segments
  parts = parts.filter(Boolean);

  // join pathname with slashes and ensure an initial slash
  const pathname = ['/'].concat(parts).join('/');

  // normalize pathname
  return normalizePath(pathname);
}

export { join };
